import { render, staticRenderFns } from "./DeleteWorkPopup.vue?vue&type=template&id=318636a7"
import script from "./DeleteWorkPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteWorkPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports